export const Armonizacion = [
    {
        "titulo" : "Información contable",
        "subtitulo" : [
            {
                "informacionTitulo" : " Estado de Situación Financiera"
            },
            {
                "informacionTitulo": " Estado de Actividades"
            },
            {
                "informacionTitulo": " Estado de Variación en la Hacienda Pública"
            },
            {
                "informacionTitulo": " Estado de Cambios en la situación financiera"
            },
            {
                "informacionTitulo": " Estado de pasivos contingentes"
            },
            {
                "informacionTitulo": " Notas a los estados financieros"
            },
            {
                "informacionTitulo": " Estado analítico del activo"
            },
            {
                "informacionTitulo": " Estado de flujo de efectivo"
            },
            {
                "informacionTitulo": " Estado analítico de la deuda y otros pasivos"
            }
        ]
    },

     {
        "titulo" : "Información presupuestaria",
        "subtitulo" : [           
            {
                "informacionTitulo": "Estado analítico de ingresos"
            },
            {
                "informacionTitulo": "Estado analítico del ejercicio del presupuesto de egresos en clasificación por objeto del gasto"
            },
            {
                "informacionTitulo": "Estado analítico del ejercicio del presupuesto de egresos en clasificación ecónomica (por tipo de gasto)"
            },
            {
                "informacionTitulo": "Estado analítico del ejercicio del presupuesto de egresos en clasificación funcional"
            },
            {
                "informacionTitulo": "Estado analítico del ejercicio del presupuesto de egresos en clasificación programática"
            },
            {
                "informacionTitulo": "Estado analítico del ejercicio del presupuesto de egresos en clasificación administrativa"
            },
            {
                "informacionTitulo": "Endeudamiento neto"
            },
            {
                "informacionTitulo": "Interés de la deuda"
            },
            {
                "informacionTitulo": "Resumen flujo de fondos (indicadores de la postura fiscal)"
            },

        ]
    },

    {
        "titulo" : "Información programática",
        "subtitulo" : [           
            {
                "informacionTitulo": "Gasto por categoría programática"
            },
            {
                "informacionTitulo": "Programas y proyectos de inversión"
            },
            {
                "informacionTitulo": "Indicadores de resultados"
            },
        ]
    },
    {
        "titulo" : "Inventario de bienes",
        "subtitulo" : [            
            {
                "informacionTitulo": "Bienes muebles"
            },
            {
                "informacionTitulo": "Bienes inmuebles"
            },
       ]
    }, 
    {
        "titulo" : "Obligaciones del título quinto",
        "subtitulo" : [            
            {
                "informacionTitulo": "Estructura de información de montos pagados por ayudas y subsidios"
            },
            {
                "informacionTitulo": "Programas con recursos federales por orden de gobierno"
            },
            {
                "informacionTitulo": "Aportaciones federales en materia de salud"
            },
            {
                "informacionTitulo": "Fondo de ayuda federal para la seguridad pública"
            },
            {
                "informacionTitulo": "Información de obligaciones pagadas o garantizadas con fondos federales"
            },
            {
                "informacionTitulo": "Ejercicio y destino de gasto federalizado y reintegros"
            },
            {
                "informacionTitulo": "Aportaciones federales de los fondos de aportaciones para la educación básica y normal y de aportaciones para la educación tecnológica y de adultos"
            },
            {
                "informacionTitulo": "Aplicación de recursos del fondo de aportaciones para el fortalecimiento de los municipios y de las demarcaciones territoriales del Distrito Federal (FORTAMUN)"
            },
       ]
    },  
    {
        "titulo" : "Obligaciones del titulo quinto(LGCG)",
        "subtitulo" : [            
            {
                "informacionTitulo": "Norma para armonizar la presentacion de la informacion adicional a la iniciativa de la ley de Ingresos"
            },
            {
                "informacionTitulo": "Norma para armonizar la presentación de la información adicional del proyecto del presupuesto de Egresos"
            },
            {
                "informacionTitulo": "Norma para armonizar la difusión a la ciudadania de la ley de ingresos del presupuesto en Egresos"
            },
            {
                "informacionTitulo": "Norma para establecer la estructura del calendario de Ingresos base mensual"
            },
            {
                "informacionTitulo": "Norma para establecer la estructura del calendario de Egresos base mensual"
            },
            {
                "informacionTitulo": "Norma para establecer la estructura de información de la relación de las cuentas bancarias productivas especificas para presentar en la cuenta pública, en las cuales se depositen los recursos federales transferidos"
            },
            {
                "informacionTitulo": "Resultados de las evaluaciones de los recursos federales ministrados a las entidades federativas"
            },
       ]
    },
  
   
]

